import React, { useState } from "react";
import {
    Box,
    Button,
    IconButton,
    Popover,
    Typography,
    useTheme
} from "@mui/material";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import XIcon from "@mui/icons-material/X";
import FacebookIcon from "@mui/icons-material/Facebook";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { toastSuccessMessage } from "../utils/utils";

const SharePopover = ({ url, title }) => {
    const [anchorEl, setAnchorEl] = useState(null);

    const handleOpen = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);

    const theme = useTheme();

    const open = Boolean(anchorEl);

    const shareLinks = {
        whatsapp: `https://wa.me/?text=${encodeURIComponent(title + " " + url)}`,
        linkedin: `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`,
        twitter: `https://twitter.com/intent/tweet?url=${encodeURIComponent(url)}&text=${encodeURIComponent(title)}`,
        facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
    };

    const copyLink = async () => {
        await navigator.clipboard.writeText(url);
        toastSuccessMessage("Link copied to clipboard!");
    };

    return (
        <>
            <Button
                startIcon={<ShareOutlinedIcon />}
                onClick={handleOpen}
                sx={{ 
                    textTransform: "none", 
                    color: theme.palette.text.primary, 
                    borderColor: theme.palette.grey[300],
                    borderRadius: "calc(0.75rem - 2px)",
                    typography: "textSm",
                    fontWeight: 500,
                    fontFamily: theme.typography.h3.fontFamily,
                }}
                variant="outlined"
            >
                Share
            </Button>

            <Popover
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
                PaperProps={{
                    sx: { p: 2, borderRadius: 3, width: 260 }
                }}
            >
                <Typography fontWeight={600} mb={2}>
                    Share this project
                </Typography>

                <Box sx={{ display: "flex", gap: 1.5, mb: 2 }}>
                    <IconButton component="a" href={shareLinks.whatsapp} target="_blank">
                        <WhatsAppIcon />
                    </IconButton>

                    <IconButton component="a" href={shareLinks.linkedin} target="_blank">
                        <LinkedInIcon />
                    </IconButton>

                    <IconButton component="a" href={shareLinks.twitter} target="_blank">
                        <XIcon />
                    </IconButton>

                    <IconButton component="a" href={shareLinks.facebook} target="_blank">
                        <FacebookIcon />
                    </IconButton>
                </Box>

                <Button
                    fullWidth
                    variant="contained"
                    startIcon={<ContentCopyIcon />}
                    onClick={copyLink}
                    sx={{ borderRadius: 2 }}
                >
                    Copy Link
                </Button>
            </Popover>
        </>
    );
};

export default SharePopover;
